query GetIndustries {
    industries {
        id
        name
    }
}
